import { PermissionConfig } from '../guard/permission-guard';

export interface SidebarAccessRule {
  modulo: string;
  entidad?: string;
  acciones?: string[];
}

const URL_RULES: Array<{ matcher: RegExp; rule: SidebarAccessRule }> = [
  { matcher: /^\/usuarios(\/|$)/, rule: { modulo: 'usuarios', entidad: 'usuario', acciones: ['LEER'] } },
  { matcher: /^\/roles(\/|$)/, rule: { modulo: 'roles', entidad: 'rol', acciones: ['LEER'] } },
  { matcher: /^\/pacientes(\/|$)|^\/atencionpaciente(\/|$)/, rule: { modulo: 'pacientes', entidad: 'paciente', acciones: ['LEER'] } },
  { matcher: /^\/servicios(\/|$)/, rule: { modulo: 'servicios', entidad: 'servicio', acciones: ['LEER'] } },
  { matcher: /^\/especialidades(\/|$)/, rule: { modulo: 'servicios', entidad: 'servicio', acciones: ['LEER'] } },
  { matcher: /^\/medicos(\/|$)/, rule: { modulo: 'medicos', entidad: 'medico', acciones: ['LEER'] } },
  { matcher: /^\/horarios(\/|$)/, rule: { modulo: 'horarios', entidad: 'horario', acciones: ['LEER'] } },
  { matcher: /^\/citas(\/|$)/, rule: { modulo: 'citas', entidad: 'cita', acciones: ['LEER'] } },
  { matcher: /^\/historial-medico(\/|$)/, rule: { modulo: 'historial_medico', entidad: 'historial', acciones: ['LEER'] } },
  { matcher: /^\/cirugias(\/|$)/, rule: { modulo: 'cirugias', entidad: 'cirugia', acciones: ['LEER'] } },
  { matcher: /^\/internaciones(\/|$)/, rule: { modulo: 'internaciones', entidad: 'internacion', acciones: ['LEER'] } },
  { matcher: /^\/doctor(\/|$)/, rule: { modulo: 'citas', entidad: 'cita', acciones: ['LEER'] } },
  {
    matcher: /^\/caja\/registrocaja(\/|$)/,
    rule: {
      modulo: 'caja',
      entidad: 'caja',
      acciones: ['VER_REGISTROS_CLINICA', 'VER_REGISTROS_FARMACIA']
    }
  },
  { matcher: /^\/caja(\/|$)/, rule: { modulo: 'caja' } },
  { matcher: /^\/farmacia\/caja(\/|$)/, rule: { modulo: 'farmacia', entidad: 'farmacia', acciones: ['VENDER', 'LEER'] } },
  { matcher: /^\/farmacia\/productos(\/|$)/, rule: { modulo: 'farmacia', entidad: 'farmacia', acciones: ['GESTIONAR_PRODUCTOS', 'LEER'] } },
  { matcher: /^\/farmacia\/compras(\/|$)/, rule: { modulo: 'farmacia', entidad: 'farmacia', acciones: ['COMPRAR', 'LEER'] } },
  { matcher: /^\/farmacia\/inventario(\/|$)/, rule: { modulo: 'farmacia', entidad: 'farmacia', acciones: ['GESTIONAR_INVENTARIO', 'LEER'] } },
  { matcher: /^\/farmacia\/almacenes(\/|$)/, rule: { modulo: 'farmacia', entidad: 'farmacia', acciones: ['GESTIONAR_ALMACENES', 'LEER'] } },
  { matcher: /^\/farmacia\/sucursales(\/|$)/, rule: { modulo: 'farmacia', entidad: 'farmacia', acciones: ['GESTIONAR_SUCURSALES', 'LEER'] } },
  { matcher: /^\/farmacia\/reportes(\/|$)/, rule: { modulo: 'farmacia', entidad: 'farmacia', acciones: ['VER_REPORTES'] } },
  { matcher: /^\/reportes(\/|$)/, rule: { modulo: 'reportes', entidad: 'reporte', acciones: ['LEER'] } },
  { matcher: /^\/atencion(\/|$)|^\/atenciones(\/|$)/, rule: { modulo: 'caja', entidad: 'caja', acciones: ['LEER', 'VER_REGISTROS', 'REGISTRAR_PAGO'] } }
];

export function getSidebarAccessRule(url: string): SidebarAccessRule | null {
  if (!url) return null;
  const normalized = String(url).trim();
  const match = URL_RULES.find((item) => item.matcher.test(normalized));
  return match?.rule ?? null;
}

export function toPermissionConfig(rule: SidebarAccessRule | null): PermissionConfig | null {
  if (!rule?.modulo || !rule?.entidad || !rule?.acciones?.length) {
    return null;
  }

  return {
    modulo: rule.modulo,
    entidad: rule.entidad,
    acciones: rule.acciones
  };
}
